import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AwsUi } from '@amzn/awsui-components-react/polaris/runtime';

// Displays console errors for AwsUI and not warnings
if (process.env.NODE_ENV === 'production') {
  AwsUi.config({ logLevel: 3 });
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
